import { GenreGroupCollection } from '@/models/GenreGroup';

export default {
    namespaced: true,
    state: {
        error: null,
        collection: null,
        // only contains genre groups that are assigned to service pages:
        servicePageCollection: null,
        // only contains genre groups that are assigned to magazin:
        magazinCollection: null,
        // only contains genre groups that are assigned to event:
        eventCollection: null,
        loaded: false,
    },
    mutations: {
        collection(state, col) {
            state.collection = col;
            state.loaded = true;
        },
        servicePageCollection(state, col) {
            state.servicePageCollection = col.filter((item) => item.page_id === 3);
        },
        magazinCollection(state, col) {
            state.magazinCollection = col.filter((item) => item.page_id === 2);
        },
        eventCollection(state, col) {
            state.eventCollection = col.filter((item) => item.page_id === 1);
        },
        isLoaded(state, loaded) {
            state.loaded = loaded;
        },
        setError(state, error) {
            state.error = error;
        },
    },
    actions: {
        async load({ commit, state }, { force = false } = {}) {
            if (state.loaded && !force) {
                return;
            }
            commit('loading', true, { root: true });
            commit('isLoaded', false);
            const collection = new GenreGroupCollection();
            // its not clear why it was filtered in thew view.
            // there are 1-5 genre page_id's not just 3
            // collection.addExtraParam(
            //     'filter',
            //     JSON.stringify([
            //         {
            //             property: 'page_id',
            //             value: [1, 2, 3],
            //             operator: 'IN',
            //         },
            //     ]),
            // );
            commit('collection', collection);
            await collection.query();
            commit('servicePageCollection', collection);
            commit('magazinCollection', collection);
            commit('eventCollection', collection);
            commit('loading', false, { root: true });
        },
    },
};
